import { Form, FormInstance } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem, InputText } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { InvoiceDocReferencedFormValues } from '@/core/domain/invoice/referencedDocument/referencedDocument.types';

interface Props {
  selectedTab?: string;
  form?: FormInstance<InvoiceDocReferencedFormValues>;
}

function InvoiceDocReferencedAccessKeyForm({ form }: Props) {
  const intl = useIntl().formatMessage;

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form form={form} layout="vertical" preserve={false}>
      <FloatingFormItem
        label={intl({ id: 'invoice.create.referenceDocument.table.acessKey' })}
        name="key"
        rules={[defaultEmptyFieldError]}
      >
        <InputText onlyNumber maxLength={44} />
      </FloatingFormItem>
    </Form>
  );
}

export default InvoiceDocReferencedAccessKeyForm;
